import React from 'react';
import {ToolTipContainer, ToolTipArrow, ToolTipTitle, ToolTipText} from './styles';

export default ({theme, title, text}: {theme: string; title: string; text: string}) => (
  <>
    <ToolTipContainer theme={theme}>
      <ToolTipArrow />
      <ToolTipTitle theme={theme}>{title}</ToolTipTitle>
      <ToolTipText theme={theme}>{text}</ToolTipText>
    </ToolTipContainer>
  </>
);
